// import _ from "lodash";
// import { store } from "../../../store";
// import { getAbility } from "../../../reducers/sessionReducer";

const assetTableColumns = [
  {
    name: "name",
    title: "Fundo",
    editable: false,
    width: 200,
  },
  {
    name: "classification",
    title: "Classificação Calculada",
    editable: false,
    width: 150,
  },
  {
    name: "cgeCode",
    title: "CGE",
    editable: false,
    width: 100,
  },
  {
    name: "cnpj",
    title: "CNPJ",
    editable: false,
    width: 140,
  },
  {
    name: "segment",
    title: "Segmento",
    editable: false,
    width: 120,
  },
  {
    name: "category",
    title: "Categoria BTG",
    editable: false,
    width: 150,
  },
  {
    name: "subcategory",
    title: "Subcategoria BTG",
    editable: false,
    width: 150,
  },
  {
    name: "cvmClass",
    title: "Classificação CVM",
    editable: false,
    width: 150,
  },
  {
    name: "anbimaClass",
    title: "Classificação Anbima",
    editable: false,
    width: 150,
  },
  {
    name: "isin",
    title: "ISIN",
    editable: false,
    width: 130,
  },
  {
    name: "topFunds",
    title: "Top Funds",
    editable: false,
    width: 200,
  },
  {
    name: "currency",
    title: "Moeda",
    editable: false,
    width: 100,
  },
  {
    name: "suitabilityBtg",
    title: "Suitability BTG",
    editable: false,
    width: 150,
  },
  {
    name: "management",
    title: "Gestão",
    editable: false,
    width: 150,
  },
  {
    name: "targetAudience",
    title: "Público Alvo",
    editable: false,
    width: 150,
  },
  {
    name: "openForSubscription",
    title: "Aberto para Captação",
    editable: false,
    width: 180,
  },
  {
    name: "minimumInvestment",
    title: "Aplicação Mínima",
    editable: false,
    width: 150,
    type: "brCurrency",
    precision: 2,
  },
  {
    name: "minimumMovement",
    title: "Movimentação Mínima",
    editable: false,
    width: 150,
    type: "brCurrency",
    precision: 2,
  },
  {
    name: "minimumBalance",
    title: "Saldo Mínimo",
    editable: false,
    width: 150,
    type: "brCurrency",
    precision: 2,
  },
  {
    name: "liquidity",
    title: "Liquidez (Cotização + Liquidação dos Recursos Resgatados) D+",
    editable: false,
    width: 120,
  },
  {
    name: "return12M",
    title: "Retorno Nominal - 12 M",
    editable: false,
    width: 120,
  },
  {
    name: "volatility12M",
    title: "Volatilidade 12 M",
    editable: false,
    width: 140,
  },
  {
    name: "sharpe12M",
    title: "Sharpe 12 M",
    editable: false,
    width: 120,
  },
  {
    name: "roaAdm",
    title: "RoA Adm",
    editable: false,
    width: 120,
  },
  {
    name: "roaPerf",
    title: "RoA Perf",
    editable: false,
    width: 120,
  },
  {
    name: "beta12M",
    title: "Beta 12 M",
    editable: false,
    width: 120,
  },
];

const assetTableLeftFixedColumns = ["name"];

export { assetTableLeftFixedColumns };
export default assetTableColumns;
